import * as z from 'zod/mini';
/**
 * Event from gateway to client (gateway -> client).
 * Sent when an actor publishes an event.
 */
export const ActorEvent = z.object({
    /** Message type identifier */
    type: z.literal('EVT'),
    /** Full actor identifier */
    actor: z.string(),
    /** Event name */
    event: z.string(),
    /** Event data */
    data: z.unknown(),
    /** Server timestamp */
    ts: z.number(),
    /** ID of the host that published the event */
    hostId: z.string(),
});
//# sourceMappingURL=ActorEvent.js.map